import React from "react";
import { useQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";

import {
  VacuumTimeline as VacuumTimelineType,
  VacuumTimelineVariables,
} from "./types/VacuumTimeline";
import {
  adaptVacuumRunData,
  VacuumEntry,
} from "features/Vacuum/VacuumTimelineChart/util";
import VacuumTimelineChart from "features/Vacuum/VacuumTimelineChart";
import Loading from "ui/Loading";
import Panel from "ui/Panel";
import { useDateRange } from "providers/WithDateRange";

import styles from "./style.module.scss";
import { useRoutes } from "utils/routes";

import QUERY from "./Query.graphql";

const VacuumTimeline: React.FunctionComponent<{
  serverId: string;
  databaseId?: string;
}> = ({ serverId, databaseId }) => {
  const { from, to } = useDateRange();
  const navigate = useNavigate();
  const { serverVacuum } = useRoutes();

  const secondaryTitle = (
    <span>
      <strong>Hint:</strong> The Timeline only shows VACUUMs that run for at
      least 1 minute.{" "}
    </span>
  );

  const { data, loading, error } = useQuery<
    VacuumTimelineType,
    VacuumTimelineVariables
  >(QUERY, {
    variables: {
      serverId,
      minDurationSecs: 60,
      startTs: from.unix(),
      endTs: to.unix(),
    },
  });
  if (loading || error) {
    return (
      <Panel title="Timeline" secondaryTitle={secondaryTitle}>
        <Loading error={!!error} />
      </Panel>
    );
  }

  const runsByLane = adaptVacuumRunData(
    data.getVacuumRuns.vacuumRuns,
    from,
    to,
  );
  const handleRunClick = (run: VacuumEntry) => {
    navigate(serverVacuum(serverId, run.vacuumIdentity));
  };
  return (
    <Panel title="Timeline" secondaryTitle={secondaryTitle}>
      <div className={styles.timelineChartWrapper}>
        <VacuumTimelineChart
          data={runsByLane}
          databaseId={databaseId}
          start={from}
          end={to}
          onClick={handleRunClick}
        />
      </div>
    </Panel>
  );
};

export default VacuumTimeline;
